<div>
  <label for="exampleInputEmail1">View Linearity</label>
  <select class="custom-select" [(ngModel)]="selected_Display" (change)="Set_DisplayLinearity()" name="selected_Display" >
    <option value="1">Display</option>
    <option value="0">Do Not Display</option>
  </select>
</div>